import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { BillingReportComposition } from './BillingReportComposition';
import { InvoiceMultipleCourierReportComposition } from '../myDeliveries/InvoiceMultipleCourierReportComposition';
import { CourierReportComposition } from './CourierReportComposition';
import { BundleReportComposition } from './BundleReportComposition';
import { VolumesReport } from './VolumesReport/VolumesReport';
import { InvoiceCourierCompanyReportComposition } from '../myDeliveries/InvoiceCourierCompanyReportComposition';
import { PageUiNavBar } from '../../components/Layout/PageNavBar/PageUiNavBar';
import './Reports.scss';
import { Region } from '../../types/orderTypes';
import CO2Report from './Co2Report/Co2Report';
import BillingCsvReport from './BillingCsvReport';
import CourierInvoice from 'pages/courier-invoice/CourierInvoice';

export default function Reports({
  region,
  limitedAccess,
}: {
  region: Region;
  limitedAccess?: boolean;
}): JSX.Element {
  return (
    <div className="reports-page">
      <div className="orders__nav u-screen-only">
        <PageUiNavBar
          bars={
            limitedAccess
              ? [
                  {
                    text: `Courier`,
                    page: '/reports/courier',
                  },
                ]
              : [
                  {
                    text: `Billing`,
                    page: '/reports',
                  },
                  {
                    text: 'Billing/CSV',
                    page: '/reports/csv',
                  },
                  {
                    text: 'Volumes',
                    page: '/reports/volumes',
                  },
                  {
                    text: 'CO2',
                    page: '/reports/co2',
                  },
                  {
                    text: `Courier`,
                    page: '/reports/courier',
                  },
                  {
                    text: `Invoice Courier`,
                    page: '/reports/invoiceCourier',
                  },
                  {
                    text: `Driving`,
                    page: '/reports/driving',
                  },
                ]
          }
        />
      </div>
      <div className="orders__content">
        <Switch>
          <Route
            exact={true}
            path="/reports"
            render={() => <BillingReportComposition />}
          />
          <Route
            exact={true}
            path="/reports/csv"
            render={() => <BillingCsvReport />}
          />
          <Route
            exact={true}
            path="/reports/volumes"
            render={() => <VolumesReport />}
          />
          <Route
            exact={true}
            path="/reports/co2"
            render={() => <CO2Report />}
          />
          <Route
            exact={true}
            path="/reports/courier"
            render={() => <CourierReportComposition region={region} />}
          />
          <Route
            exact={true}
            path="/reports/invoiceCourier"
            render={() => <CourierInvoice region={region} isDispatcher />}
          />
          <Route
            exact={true}
            path="/reports/invoiceCourierOld"
            render={() => (
              <InvoiceMultipleCourierReportComposition region={region} />
            )}
          />
          <Route
            exact={true}
            path="/reports/invoiceCourierCompany"
            render={() => (
              <InvoiceCourierCompanyReportComposition region={region} />
            )}
          />
          <Route
            exact={true}
            path="/reports/driving"
            render={() => <BundleReportComposition />}
          />
        </Switch>
      </div>
    </div>
  );
}

export function PartnerReports({ region }: { region: Region }): JSX.Element {
  return (
    <div className="reports-page">
      <div className="orders__nav u-screen-only">
        <PageUiNavBar
          bars={[
            {
              text: `Courier company`,
              page: '/reports/invoiceCourierCompany',
            },
            {
              text: `Courier rating`,
              page: '/reports/courier',
            },
          ]}
        />
      </div>
      <div className="orders__content">
        <Switch>
          <Route
            exact={true}
            path="/reports/invoiceCourierCompany"
            render={() => (
              <InvoiceCourierCompanyReportComposition region={region} />
            )}
          />
          <Route
            exact={true}
            path="/reports/courier"
            render={() => <CourierReportComposition region={region} />}
          />
        </Switch>
      </div>
    </div>
  );
}
